const styles = (theme) => ({
  root: {},
  iconFieldWrapper: {
    display: 'flex',
    alignItems: 'flex-start',
    paddingBottom: '20px',
    paddingTop: '20px',
    position: 'relative',
    borderTop: `1px solid ${theme.palette.border.light}`,
    flexGrow: 1,
    [theme.breakpoints.up('lg')]: {
      width: '50%',
    },
  },
  label: {
    color: theme.palette.text.dark,
    fontWeight: 600,
    fontFamily: 'Calibre',
    lineHeight: '1rem',
    marginBottom: 5,
    fontSize: '1rem',
    [theme.breakpoints.up('sm')]: {
      fontSize: '1.25rem',
    },
  },
  value: {
    fontSize: '1.125rem',
    [theme.breakpoints.up('sm')]: {
      fontSize: '1.375rem',
    },
  },
  icon: {
    background: theme.palette.background.lighter,
    padding: theme.spacing.unit,
    borderStyle: 'solid',
    borderWidth: '1px',
    borderColor: theme.palette.border.lighter,
    borderRadius: '100px',
    marginRight: 20,
    width: 40,
    height: 40,
    color: theme.palette.custom.accounts,
  },
  contentRow: {
    [theme.breakpoints.up('lg')]: {
      width: '250px',
    },
  },
  line: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  heading: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    paddingTop: theme.spacing.unit * 2.5,
    paddingBottom: '15px',
    [theme.breakpoints.up('sm')]: {
      flexDirection: 'row',
      paddingBottom: 0,
    },
  },
  updating: {
    color: theme.palette.primary.dark,
    fontSize: '1.0625',
    fontWeight: 500,
    paddingRight: theme.spacing.unit / 2,
    [theme.breakpoints.up('sm')]: {
      fontSize: '1.125rem',
    },
  },
  bottomText: {
    '&&': {
      fontSize: '1.125rem',
      [theme.breakpoints.up('sm')]: {
        fontSize: '1.25rem',
      },
    },
  },
  invalidAccount: {
    color: '#CE2C29',
  },
});

export default styles;
